import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {MediaInterface} from '../../../interfaces'

@Component({
  selector: 'dmmp-item-menu',
  templateUrl: './item-menu.component.html'
})
export class ItemMenuComponent implements OnInit {

  @Input() menuItem
  @Input() menuLevel
  @Output() actionEmitter = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Output() externalLink = new EventEmitter()
  medias: MediaInterface[] = [
    {style: 'max_650x650', media: '(min-width: 326px)'},
    {style: 'max_325x325', media: '(max-width: 325px)'},
  ]

  constructor() {
  }

  ngOnInit(): void {
  }

}
